import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-placeholder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './placeholder.component.html',
})
export class PlaceholderComponent {
  moduleName: string;
  constructor(route: ActivatedRoute) {
    this.moduleName = route.snapshot.url[0]?.path ?? 'Module';
  }
}
